// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3iwsC","buttons":"SendReceipts_buttons__3sJA9","email":"SendReceipts_email__3OujO","bookApptTitle":"SendReceipts_bookApptTitle__DaV0z"};